"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
const identify = (id, properties) => {
    // @ts-ignore
    analytics.identify(id, properties);
};
const page = (name, properties) => {
    // @ts-ignore
    analytics.page(name, properties);
};
const track = (name, properties) => {
    // @ts-ignore
    analytics.track(name, properties);
};
exports.AnalyticsService = {
    page,
    identify,
    track,
};
//# sourceMappingURL=index.js.map